import * as React from "react";
import Collapse from "../../core/Collapse/Collapse";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import chevronBottom from "../../iconic/chevron-bottom.svg";
import Checkbox from "../Checkbox/Checkbox";

interface ICheckboxValue {
    key: string;
    value: string;
}

interface ITableCheckboxListFilterProps extends ITranslationProps {
    onChange: (selectedValues: string[]) => void;
    values: ICheckboxValue[];
    selectedValues: string[];
}

interface ITableCheckboxListFilterState {
    showCheckboxes: boolean;
}

class TableCheckboxListFilter extends React.Component<ITableCheckboxListFilterProps, ITableCheckboxListFilterState> {

    constructor(props: ITableCheckboxListFilterProps) {
        super(props);

        this.state = { showCheckboxes: false };
        this.toggleCheckboxVisibility = this.toggleCheckboxVisibility.bind(this);
        this.onCheckChange = this.onCheckChange.bind(this);
    }

    public render() {

        const checkboxes: React.ReactNode[] = [];
        this.props.values.forEach((item, index) => {

            let checked = false;
            if (this.props.selectedValues.indexOf(item.value) > -1) {
                checked = true;
            }

            checkboxes.push(
                <div key={index} className="form-check ">
                    <Checkbox name={item.key} value={item.value} checked={checked} onChecked={this.onCheckChange} />
                </div>
            );
        });

        return (
            <div>
                <button className="btn btn-outline-secondary"
                    title={this.props.t("TableCheckboxListFilter.SelectOptions")} onClick={this.toggleCheckboxVisibility} >
                    <img src={chevronBottom} className="mr-1" />
                    {this.props.t("TableCheckboxListFilter.SelectOptions")}
                </button>
                <Collapse isOpen={this.state.showCheckboxes}>
                    {checkboxes}
                </Collapse>
            </div>
        );
    }

    private toggleCheckboxVisibility() {
        this.setState({ showCheckboxes: !this.state.showCheckboxes });
    }

    private onCheckChange(value: string, checked: boolean) {

        const selectedValues = this.props.selectedValues;

        if (checked) {
            selectedValues.push(value);
        } else {
            const index = selectedValues.indexOf(value);
            selectedValues.splice(index, 1);
        }

        this.props.onChange(selectedValues);
    }
}

export default translateComponent(TableCheckboxListFilter);
export { ICheckboxValue };



// WEBPACK FOOTER //
// ./src/core/TableCheckboxListFilter/TableCheckboxListFilter.tsx